import React, { useState, useEffect } from "react";
import "./homeCarouselSection.css"; // Importing the CSS file
import { useNavigate } from "react-router-dom";
import StarIcon from "./assets/starIcon.png";
import LocationIcon from "./assets/locationIcon.png";
import Spinner from "../../components/spinner";

const HomeCarouselSection = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    criminalLaw: [],
    corporateLaw: [],
    familyLaw: [],
  });

  const DEFAULT_SUGGESTION = {
    title: "United States, IL, 60602, Chicago",
    id: "here:cm:namedplace:21002647",
    address: {
      label: "Chicago, IL, United States",
      countryCode: "USA",
      state: "Illinois",
      stateCode: "IL",
      // postalCode, city, county, etc. only if you need them:
      postalCode: "60602",
      city: "Chicago",
    },
    language: "en",
    localityType: "city",
    resultType: "locality",
    highlights: {
      title: [
        { start: 0, end: 13 },
        { start: 15, end: 17 },
        { start: 19, end: 24 },
        { start: 26, end: 33 },
      ],
    },
  };

  const DEFAULT_COORDS = {
    latitude: 41.88425,
    longitude: -87.63245,
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addressDetails, setAddressDetails] = useState({
    ...DEFAULT_COORDS,
  });

  const { latitude, longitude } = addressDetails;

  const handleCriminalLaw = () => {
    const queryParams = new URLSearchParams({
      practice_area: "criminal-law",
      radius: "40000", // You can make radius dynamic if needed
      latitude: latitude,
      longitude: longitude,
      location: DEFAULT_SUGGESTION.title,
    }).toString();

    // Navigate to the results page with query parameters
    navigate(`/search-results?${queryParams}`);
  };

  const handleFamilyLaw = () => {
    const queryParams = new URLSearchParams({
      practice_area: "family-law",
      radius: "40000", // You can make radius dynamic if needed
      latitude: latitude,
      longitude: longitude,
      location: DEFAULT_SUGGESTION.title,
    }).toString();

    // Navigate to the results page with query parameters
    navigate(`/search-results?${queryParams}`);
  };

  const handleCorporateLaw = () => {
    const queryParams = new URLSearchParams({
      practice_area: "corporate-law",
      radius: "40000", // You can make radius dynamic if needed
      latitude: latitude,
      longitude: longitude,
      location: DEFAULT_SUGGESTION.title,
    }).toString();

    // Navigate to the results page with query parameters
    navigate(`/search-results?${queryParams}`);
  };

  useEffect(() => {
    // API call to fetch the data (explicitly using GET method)
    fetch("/api/home/getLawyersHomeCarousel", {
      method: "GET", // Explicit GET request
      headers: {
        "Content-Type": "application/json", // Specify content type if needed
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setData({
          criminalLaw: data.data["criminal-law"],
          corporateLaw: data.data["corporate-law"],
          familyLaw: data.data["family-law"],
        });
        setLoading(false);
      })
      .catch((error) => {
        setError("Failed to fetch lawyer data.");
        setLoading(false);
      });
  }, []);

  const renderLawyerCards = (lawyers) => {
    return lawyers.map((lawyer, index) => (
      <div
        className="lawyer-carousel-card"
        key={index}
        onClick={() => {
          navigate(`/lawyer-detail/${lawyer.user_id}`, {
            state: { lawyer },
          });
        }}
      >
        <div className="lawyer-carousel-card-header">
          <img
            src={lawyer.profile_photo_url}
            alt={`${lawyer.first_name} ${lawyer.last_name}`}
            className="lawyer-carousel-photo"
          />
          <div className="lawyer-carousel-info">
            <h3 className="lawyer-carousel-name">{`${lawyer.first_name} ${lawyer.last_name}`}</h3>
            <p className="lawyer-carousel-role">{lawyer.role}</p>

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src={StarIcon}
                style={{ width: "24px", height: "24px" }}
                alt="rating"
              />
              <p className="lawyer-carousel-rating">{`${lawyer.average_rating} . ${lawyer.number_of_reviews} reviews`}</p>
            </div>
            <p className="lawyer-carousel-specialty">
              {lawyer.education_institution}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src={LocationIcon}
            style={{ width: "16px", height: "16px" }}
            alt="location-icon"
          />
          <p className="lawyer-carousel-location">{`${lawyer.city}, ${lawyer.state}`}</p>
        </div>

        <p className="lawyer-carousel-availability">
          {lawyer.has_schedule
            ? "Available to book"
            : "No upcoming availability"}
        </p>
        <button
          className={`lawyer-carousel-book-btn ${
            !lawyer.has_schedule ? "lawyer-carousel-book-btn-disabled" : ""
          }`}
          aria-label={`Book ${lawyer.first_name} ${lawyer.last_name} online`}
          disabled={!lawyer.has_schedule}
        >
          Book Online
        </button>
      </div>
    ));
  };

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="lawyer-carousel-section">
      <div className="lawyer-carousel-category">
        <div className="lawyer-carousel-title-div">
          <h2>Top-Rated Criminal Attorneys</h2>
          <p className="carousel-show-all" onClick={handleCriminalLaw}>
            Show all
          </p>
        </div>
        <div className="lawyer-carousel-slider">
          {renderLawyerCards(data.criminalLaw)}
        </div>
      </div>

      <div className="lawyer-carousel-category">
        <div className="lawyer-carousel-title-div">
          <h2>Premier Family Lawyers</h2>
          <p className="carousel-show-all" onClick={handleFamilyLaw}>
            Show all
          </p>
        </div>
        <div className="lawyer-carousel-slider">
          {renderLawyerCards(data.familyLaw)}
        </div>
      </div>

      <div className="lawyer-carousel-category">
        <div className="lawyer-carousel-title-div">
          <h2>Top-Rated Corporate Advisors</h2>
          <p className="carousel-show-all" onClick={handleCorporateLaw}>
            Show all
          </p>
        </div>
        <div className="lawyer-carousel-slider">
          {renderLawyerCards(data.corporateLaw)}
        </div>
      </div>
    </div>
  );
};

export default HomeCarouselSection;